import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa(s): ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Marcadores: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Usuário: ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Empresa: ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    overlayClassName: 'ss-detalhe-agendamento',
    placement: "top",
    color: _ctx.props.agendamento.cor
  }, {
    title: _withCtx(() => [
      _createElementVNode("b", null, _toDisplayString(_ctx.props.agendamento.tipoAgendamentoDescricao) + ": ", 1),
      _createTextVNode(_toDisplayString(_ctx.props.agendamento.titulo), 1),
      _hoisted_1,
      (_ctx.UtilitarioGeral.valorValido(_ctx.props.agendamento.pessoas))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(_toDisplayString(_ctx.props.agendamento.pessoas), 1),
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      (_ctx.UtilitarioGeral.valorValido(_ctx.props.agendamento.marcadores))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.props.agendamento.marcadores), 1),
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      ((_ctx.props.agendamento.codigoUsuario !== _ctx.props.codigoUsuarioAutenticado))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(_ctx.props.agendamento.nomeUsuario), 1),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      ((_ctx.props.apresentarEmpresa))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(_toDisplayString(_ctx.props.agendamento.nomeEmpresa), 1),
            _hoisted_13
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["color"]))
}